import React from 'react';
import {
  View,
  ScrollView,
  StyleSheet,
  Dimensions,
  Platform,
  KeyboardAvoidingView,
  Modal as RNModal,
  TouchableWithoutFeedback
} from 'react-native';
import { Button, Card, Icon, Text, useTheme } from '@ui-kitten/components';

const { height } = Dimensions.get('window');

interface ITenantModalProps {
  visible: boolean;
  title: string;
  message: string;
  icon: string;
  noBtnClick?: () => void;
  primaryButtonText: string;
  onPrimaryButton: () => void;
  visibleSecondaryButton: boolean;
  secondaryButtonText?: string;
  onSecondaryButton?: () => void;
  testingAttributes?: {
    accessible: boolean;
    accessibilityLabel: string;
    testID: string;
  };
}

export const TenantModal = (props: ITenantModalProps) => {
  const theme = useTheme();

  const styles = StyleSheet.create({
    backdrop: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'center'
    },
    wrapper: {
      width: '90%',
      alignSelf: 'center',
      borderRadius: 16,
      overflow: 'hidden'
    },
    card: {
      flexGrow: 1
    },
    iconContainer: {
      height: 100,
      width: 100,
      alignSelf: 'center',
      marginBottom: 15
    },
    buttonArea: {
      flexDirection: 'column',
      justifyContent: 'center',
      paddingBottom: 5
    },
    buttonStyle: {
      width: '100%',
      marginVertical: 5
    },
    message: {
      textAlign: 'center',
      marginTop: 4,
      paddingHorizontal: 10
    },
    ScrollContent: { height: height * 0.42 },
    containerStyle: { flexGrow: 1 }
  });

  return (
    <RNModal
      visible={props.visible}
      animationType="fade"
      transparent
      onRequestClose={props.noBtnClick}
      {...props.testingAttributes}>
      <TouchableWithoutFeedback onPress={props.noBtnClick}>
        <View style={styles.backdrop}>
          <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} style={styles.wrapper}>
            <Card disabled={true} style={styles.card}>
              <View style={styles.buttonArea}>
                <Button style={styles.buttonStyle} size="large" onPress={props.onPrimaryButton}>
                  <Text>{props.primaryButtonText}</Text>
                </Button>
                {props.visibleSecondaryButton && props.onSecondaryButton && (
                  <Button style={styles.buttonStyle} appearance="ghost" size="large" onPress={props.onSecondaryButton}>
                    <Text>{props.secondaryButtonText}</Text>
                  </Button>
                )}
              </View>
              <View style={styles.ScrollContent}>
                <ScrollView
                  keyboardShouldPersistTaps="handled"
                  showsVerticalScrollIndicator={false}
                  contentContainerStyle={styles.containerStyle}>
                  <View style={styles.iconContainer}>
                    <Icon status="primary" fill={theme['color-primary-500']} name={props.icon} />
                  </View>
                  <Text category="h5" style={styles.message}>
                    {props.title}
                  </Text>
                  <Text category="p1" appearance="hint" style={styles.message}>
                    {props.message}
                  </Text>
                </ScrollView>
              </View>
            </Card>
          </KeyboardAvoidingView>
        </View>
      </TouchableWithoutFeedback>
    </RNModal>
  );
};
